package top.wcpe.allincore.ui.runtime.theme

import top.wcpe.allincore.ui.runtime.internal.concurrent.ThreadLocalRef
import kotlin.jvm.JvmStatic

/**
 * 当前线程渲染上下文中的 [ControlTheme]。
 *
 * 由 `UIRenderer.render` 入口在帧开头压栈、结束时恢复；Renderer 通过 [current] 取值。
 * 这样非交互 Renderer 完全无需关心主题，仅交互控件按需读取。
 *
 * 线程隔离：fabric 渲染线程单线程，bukkit 服务端无 Renderer 调用，故线程局部
 * （[ThreadLocalRef]，槽位可变、与迁移前 ThreadLocal get/set 语义一致）
 * 既满足正确性也无需 ConcurrentHashMap 之类的代价。
 */
object ThemeAccess {

    /** 线程局部可变槽位：[ThreadLocalRef] 契约仅暴露 get()，故以容器字段承载可写主题。 */
    private class Holder {
        var theme: ControlTheme = ControlTheme.defaultFallback()
    }

    private val holder: ThreadLocalRef<Holder> = ThreadLocalRef { Holder() }

    /** 取得当前主题，永不返回 null（未设置时返回 [ControlTheme.defaultFallback]）。 */
    @JvmStatic
    fun current(): ControlTheme = holder.get().theme

    /** 设置当前主题。仅供 `UIRenderer` 在渲染入口调用，业务代码不应直接使用。 */
    @JvmStatic
    fun set(theme: ControlTheme?) {
        holder.get().theme = theme ?: ControlTheme.defaultFallback()
    }
}
